import { KEYMAKER_URL, GET_PLUGIN_URL, PRICE_URL, REFERRAL_URL } from '@app/routes';
import { Link } from '@ui-kit';

export let MENU_LIST = [
  {
    component: (
      <Link to={KEYMAKER_URL} theme="text">
        KeyMaker
      </Link>
    ),
  },
  {
    component: (
      <Link to={GET_PLUGIN_URL} theme="text">
        Get plugin
      </Link>
    ),
  },
  {
    component: (
      <Link to={PRICE_URL} theme="text">
        Price
      </Link>
    ),
  },
  {
    component: (
      <Link to={REFERRAL_URL} theme="text" className="bold-color">
        Free month
      </Link>
    ),
  }
];
